import React from 'react';
import './WhatsAppButton.css';
import whatsappicon2 from '../Images/whatsappicon2.png'
import { motion } from "framer-motion";

const WhatsAppButton = () => {
  const whatsappNumber = "+923265292748";
  const message = encodeURIComponent("Hello! Can I get more info?");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <motion.a 
      href={whatsappUrl} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="whatsapp-button"
      initial={{ x: 50, y: 50, opacity: 0 }} // Start position (bottom-right)
      animate={{ x: 0, y: 0, opacity: 1 }} // End position (sliding left & up)
      transition={{ duration: 0.8, ease: "easeOut" }} // Smooth animation
    >
      <img src={whatsappicon2} alt="WhatsApp" className='box'/>
      <p>WhatsApp</p>
    </motion.a>
  );
};

export default WhatsAppButton;
